<template>
  <div data-app class="object-menu-container" :style="[xPosition, yPosition]">
    <object-menu-item
      :disabled="!hasPermission('show')"
      @click.native="openForm('view')"
      :action="$t('View')"
    >
      <ViewSVG />
    </object-menu-item>

    <object-menu-item
      :disabled="!hasPermission('show')"
      @click.native="openDetailForm()"
      :action="$tc('Detail', 2)"
    >
      <DetailSVG />
      <!-- <img src="../../../../assets/home/objectMenu/detail.png" class="detail-img"> -->
    </object-menu-item>

    <object-menu-item
      :disabled="!hasPermission('update')"
      @click.native="openForm('edit')"
      :action="$t('Edit')"
    >
      <EditSVG />
    </object-menu-item>

    <object-menu-item
      v-if="actionFrom === 'fc_microduct_bundle'"
      :disabled="false"
      @click.native="$emit('splitBundle', object.uuid)"
      :action="object.split ? $t('Join') : $t('Split')"
    >
      <v-icon style="left: -3px; margin-right: -6px">{{ object.split ? 'linear_scale' : 'alt_route' }}</v-icon>
    </object-menu-item>

    <object-menu-item
      v-if="!(actionFrom === 'fc_cluster_tool' && object.type === 'Closure')"
      @click.native="$emit('removeFromCable', object.uuid)"
      :action="$t('Remove')"
    >
      <RemoveSVG />
    </object-menu-item>
  </div>
</template>

<script>
import ObjectMenuItem from "./ObjectMenuItem";

import ViewSVG from "@/assets/home/objectMenu/view.svg";
import EditSVG from "@/assets/home/objectMenu/edit.svg";
import RemoveSVG from "@/assets/home/objectMenu/remove.svg";
import DetailSVG from "@/assets/home/objectMenu/detail.svg";

export default {
  components: {
    ObjectMenuItem,
    ViewSVG,
    EditSVG,
    DetailSVG,
    RemoveSVG
  },

  props: ["event", "object", "actionFrom"],

  computed: {
    /**
     * Finds and stores the position where the object menu should be place in the x axis.
     *
     * @returns {{right: number}|{left: string}}
     * If the click on the map is in a coordinate that allows the menu to
     * appear entirely inside the screen, the menu is placed relatively to the left side of the parent element.
     * If the menu would not be able to be entirely contained in the screen, it is placed along the right side
     * of the map.
     */
    xPosition() {
      return { left: "140px" };
    },
    /**
     * Finds and stores the position where the object menu should be place in the y axis.
     *
     * @returns {{top: string}|{bottom: number}}
     * If the click on the map is in a coordinate that allows the menu to
     * appear entirely inside the screen, the menu is placed relatively to the top of the parent element.
     * If the menu would not be able to be entirely contained in the screen, it is placed along the bottom of the map.
     */
    yPosition() {
      return { top: "160px" };
    }
  },

  methods: {
    /**
     * Opens the object's form, when the user clicks the View button, if the user has View permission for that kind
     * of object.
     *
     * @param {string} action - type of action the user is trying to do.
     */
    openForm(action) {
      if (this.hasPermission("show")) {
        this.$emit("openForm", action);
      }
    },

    /**
     * Opens the object's details form, when the user clicks the Details button, if the user has View permission for
     * that kind of object.
     */
    openDetailForm() {
      if (this.hasPermission("show")) {
        this.$emit("openDetailForm");
      }
    },

    /**
     * Checks if the the user has permission to do a certain action of the selected object.
     * @param {string} action - type of action the user is trying to do.
     * @returns {boolean}  true if the current user has permission, false if he doesn't.
     */
    hasPermission(action) {
      let objectType = this.getObjectType();
      let permissionsName = objectType + "_" + action;
      if (objectType === "workspace") {
        return this.$store.getters.hasPermissionInRole(
          "workspace_fibercloud_show",
          "fibercloud_web"
        );
      } else {
        return this.$store.getters.hasPermissionInRole(
          permissionsName,
          "fibercloud_web"
        );
      }
    },

    /**
     * Finds the type of the selected object.
     *
     * @returns {string} the type of the object.
     */
    getObjectType() {
      if (this.object.objectType !== undefined) {
        return this.object.objectType;
      } else {
        return this.object.type.toLowerCase();
      }
    }
  }
};
</script>

<style scoped>
.object-menu-container {
  position: absolute;
  z-index: 60;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}

.object-menu-submenu {
  position: absolute;
  z-index: 25;
  display: flex;
  flex-direction: column;
  left: 100px;
  box-shadow: 6px 2px 6px -2px rgba(0, 0, 0, 0.3);
  width: 100px;
  background-color: white;
  height: 56px;
  top: 28px;
}

.object-submenu-item {
  z-index: 25;
  width: 100px;
  background-color: white;
  height: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 11px;
}

.object-submenu-item:hover {
  background: #f1f1f1;
}

.detail-img {
  width: 13px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectMenu/WindowObjectMenu.vue